module.exports = __webpack_public_path__ + "img/logo.c0aef7b6.png";